import React, { useState, useEffect } from "react";
import dateFormat from 'dateformat';
import * as XLSX from 'xlsx';
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import Modalv2 from "../../../components/tables/Modalv2";
import ValidView from "../../../components/app/validView";
import Spinner from "react-bootstrap/Spinner";
import ModalMultiInbursaUsers from "./ModalMultiInbursaUsers.js";
import ModalExportExcel from "../../../components/tables/ModalExportExcel";
import CustomHeader from "../../../components/tables/CustomHeader";
import { searchUtils } from "../../../components/tables/searchUtils";
import ModalAdvisorStatus from "./ModalAdvisorStatus";

const InbursaUsers = () => {
	const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
	const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

	const [resetGridTable, setResetGridTable] = useState(false);
	const [isLoading, setLoading] = useState(true);
	const [rowsLoading, setRowsLoading] = useState(false);
	const [columnsGrid, setColumnsGrid] = useState([]);
	const [show, setShow] = useState(false);
	const [show_sc, setshow_sc] = useState(false);
	const [show_excel, setshow_excel] = useState(false);
	const [selectMultiRows, setSelectMultiRows] = useState([]);
	const [selectedRowsIds, setSelectedRowsIds] = useState([]);

	// Modal Advisor Status State
	const [showModalAdvisor, setShowModalAdvisor] = useState(false);
	const [advisorData, setAdvisorData] = useState(null);

	const handleClose = () => setShow(false);
	const handleClose_sc = () => setshow_sc(false);
	const handleClose_excel = () => setshow_excel(false);
	const handleCloseAdvisor = () => {
		setShowModalAdvisor(false);
		setAdvisorData(null);
	};

	const [objFilter, setObjFilter] = useState([]);
	const [stringFilter, setStringFilter] = useState(null);
	const { allowWrite, allowView, userToken } = ValidView("InbursaUsers");

	const nameView = "Client";
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(rowsPerPageArray[0]);
	const [dataItem, setItem] = useState({
		codeItem: 0,
		typeView: "",
		nameView: "",
	});

	const [flagSelectAll, setFlagSelectAll] = useState(false);

	const selectUnselectAllRows = () => {
		setFlagSelectAll(true);
	};

	useEffect(() => {
		if (flagSelectAll) {
			setSelectMultiRows(selectedRowsIds);
			setFlagSelectAll(false);
		}
	}, [flagSelectAll, selectedRowsIds]);

	const handleReloadComponent = () => {
		setPage(1);
		setResetGridTable(!resetGridTable);
	};

	useEffect(() => {
		if (allowView) {
			setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows, handleAdvisorClick }));
			setRowsLoading(true);
		}
	}, [allowView, allowWrite]);

	const handleAdvisorClick = (data) => {
		setAdvisorData(data);
		setShowModalAdvisor(true);
	};

	const modalDetail = (codeItem, typeView) => {
		setShow(true);
		setItem({ codeItem, typeView, nameView });
	};

	const modal_sc = (codeItem, typeView) => {
		setshow_sc(true);
	};

	const modal_excel = () => {
		setshow_excel(true);
	};

	const changeDelay = (textSearch, tableManager, column) => {
		const { searchApi } = tableManager;
		const { searchText, setSearchText } = searchApi;
		const setSearchAndFilter = (searchText, stringFilter) => {
			setSearchText(searchText);
			setStringFilter(stringFilter);
		};
		searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
	};

	const updateSelectMultiRows = (number) => {
		setSelectMultiRows(prevRows => {
			const index = prevRows.indexOf(number);
			if (index === -1) {
				return [...prevRows, number];
			} else {
				return prevRows.filter(item => item !== number);
			}
		});
	};

	function sleep(time) {
		return new Promise((resolve) => setTimeout(resolve, time)
		)
	}

	const onRowsRequest = async (requestData, tableManager) => {
		setLoading(true);
		const { rowSelectionApi } = tableManager;
		const { setSelectedRowsIds } = rowSelectionApi;

		const requestOptions = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + userToken
			}
		};

		const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/inbursa/inbursaUsers?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
			.then((response) => {
				setLoading(false);
				return response.json();
			}).catch(console.warn);

		if (!response?.data) return;

		if (selectMultiRows.length > 0) {
			sleep(800).then(() => {
				setSelectedRowsIds(selectMultiRows);
			})
		}

		return {
			rows: response.data,
			totalRows: response.total_count,
			selectedRowsIds: selectMultiRows
		};
	};

	const OnPageChange = (event) => {
		setPage(event);
	}


	let dataSendInbursaUsers = { 'typeView': 'Edit', 'codeItem': selectMultiRows, 'nameView': 'Send InbursaUsers' };
	const urlBaseExport = '/inbursa/inbursaUsers/exportToExcel?page=1&perPage=9999';

	const transformExcel = (workbook) => {
		const sheetName = workbook.SheetNames[0];
		const worksheet = workbook.Sheets[sheetName];

		const range = XLSX.utils.decode_range(worksheet['!ref']);
		let enabledColIndex = -1;

		// Find column headers and process dates / locate 'enabled' column
		for (let C = range.s.c; C <= range.e.c; ++C) {
			const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
			const cell = worksheet[cellAddress];
			if (!cell) continue;

			// Track the enabled/Active column for activeAdvisor
			if (cell.v === 'enabled' || cell.v === 'Active') {
				enabledColIndex = C;
			}

			// Check for date columns to format
			if (cell.v === 'createdAtActive' || cell.v === 'createdAtInactive' || cell.v === 'Fecha Activación' || cell.v === 'Fecha Inactivación' || cell.v === 'Fecha de Creación Activo' || cell.v === 'Active') {
				for (let R = range.s.r + 1; R <= range.e.r; ++R) {
					const dateCellAddress = XLSX.utils.encode_cell({ r: R, c: C });
					const dateCell = worksheet[dateCellAddress];
					if (dateCell && dateCell.v) {
						const date = new Date(dateCell.v);
						if (!isNaN(date.getTime())) {
							dateCell.v = dateFormat(date, "dd/mm/yyyy HH:MM:ss");
							dateCell.t = 's'; // Change type to string
						}
					}
				}
			}
		}

		if (enabledColIndex !== -1) {
			const newColIndex = range.e.c + 1;

			const headerAddress = XLSX.utils.encode_cell({ r: 0, c: newColIndex });
			worksheet[headerAddress] = { v: 'activeAdvisor', t: 's' };

			// Add values for each row
			for (let R = range.s.r + 1; R <= range.e.r; ++R) {
				const srcAddress = XLSX.utils.encode_cell({ r: R, c: enabledColIndex });
				const srcCell = worksheet[srcAddress];
				const val = srcCell ? srcCell.v : false;
				const isActive = (val === true || val === 'true' || val === 1 || val === '1');

				const destAddress = XLSX.utils.encode_cell({ r: R, c: newColIndex });
				worksheet[destAddress] = { v: isActive ? 'Activo' : 'Inactivo', t: 's' };
			}

			range.e.c = newColIndex;
			worksheet['!ref'] = XLSX.utils.encode_range(range);
		}

		return workbook;
	};

	return (
		<>
			<div className="tableWrapper">
				{!rowsLoading
					? (<Spinner animation="border" role="status" variant="secondary" >
						<span className="visually-hidden">Loading...</span>
					</Spinner>) : (<>
						<GridTable
							key={resetGridTable}
							columns={columnsGrid}
							rowIdField={'code'}
							onRowsRequest={onRowsRequest}
							isLoading={isLoading}
							pageSizes={rowsPerPageArray}
							pageSize={pageSize}
							onPageSizeChange={setPageSize}
							onPageChange={OnPageChange}
							selectedRowsIds={selectedRowsIds}
							onSelectedRowsChange={setSelectedRowsIds}
							showSearch={false}
							showColumnVisibilityManager={false}
							highlightSearch={false}
							minSearchChars={3}
							components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectMultiRows} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter} /> }}
						/>
					</>)}
			</div>
			<Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={handleReloadComponent} />

			<ModalMultiInbursaUsers show={show_sc} handleClose={handleClose_sc} dataItem={dataSendInbursaUsers} setRenderRows={[]} />
			<ModalExportExcel
				show={show_excel}
				handleClose={handleClose_excel}
				objTextFind={stringFilter}
				urlBaseExport={urlBaseExport}
				nameFile={'InbursaUsers.xlsx'}
				transformExcel={transformExcel}
			/>
			<ModalAdvisorStatus
				show={showModalAdvisor}
				handleClose={handleCloseAdvisor}
				advisorData={advisorData}
				setRenderRows={handleReloadComponent}
			/>
		</>
	);
};

export default InbursaUsers;